import React, { useState } from "react";
import {useNavigate, useSearchParams} from "react-router-dom";
import {Container, Form, Button, Alert, Card, Row, Col} from "react-bootstrap";
import Cookies from "js-cookie";
import axios from "axios";
import {SERVER_BASE_URL} from "../Constants";

export default function CreateWorkout() {
    const [searchParams] = useSearchParams();
    const competitionId = searchParams.get("competition_id");
    const competitionName = searchParams.get("competition_name");
    const [scoringType, setScoringType] = useState("");
    const [tieBreakerType, setTieBreakerType] = useState("");
    const [name, setName] = useState("");
    const [maxReps, setMaxReps] = useState("");
    const [timeCap, setTimeCap] = useState("");
    const [description, setDescription] = useState("");
    const [errorMessage, setErrorMessage] = useState("");

    const navigate = useNavigate();


    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const token =  Cookies.get("token");

            const response = await axios.post(SERVER_BASE_URL + 'api/workouts/create', {
                    workout_name: name,
                    workout_description: description,
                    competition_id: competitionId,
                    scoring_type: scoringType,
                    tie_breaker_type: tieBreakerType,
                    max_points : maxReps,
                    time_cap: timeCap,
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`, // Pass the token in the Authorization header
                    },
                });

            console.log(response);

            // Handle successful response
            if (response.status === 200) {
                setErrorMessage("");
                // Redirect to the dashboard
                navigate(`/competition/${competitionId}`);
            } else {
                setErrorMessage(response.data || 'Login failed. Please try again.');
            }
        } catch (err) {
            // Handle API errors
            setErrorMessage(err.response.data || 'An error occurred during login.');
        }
        console.log("Creating workout:", { competitionId, competitionName, name });
        // Add API call here
    };

    const handleTimeCapChange = (e) => {
        const value = e.target.value;
        const regex = /^([0-1][0-9]|2[0-3]):([0-5][0-9]):([0-5][0-9])$/;

        if (value === "" || regex.test(value)) {
            setTimeCap(value);
        }
    };



    return (
        <Container className="d-flex justify-content-center align-items-center p-5">
            <Card style={{ width: "40rem" }} className="p-4 shadow">
                {errorMessage && (
                    <Alert variant="danger" onClose={() => setErrorMessage("")} dismissible>
                        {errorMessage}
                    </Alert>
                )}
                <Card.Body>
                    <h2 className="text-center mb-4">Create Workout for {competitionName}</h2>
                    <Form onSubmit={handleSubmit}>
                        <Form.Group as={Row} controlId="workoutName" className="mb-3">
                            <Form.Label sm="3" column="sm">Workout Name:</Form.Label>
                            <Col sm="9">
                                <Form.Control
                                    type="text"
                                    name="name"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    required />
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} controlId="workoutName" className="mb-3">
                            <Form.Label sm="3" column="sm">Description:</Form.Label>
                            <Col sm="9">
                            <Form.Control
                                as="textarea"
                                name="description"
                                value={description}
                                onChange={(e) => setDescription(e.target.value)}
                                required />
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} controlId="description" className="mb-3">
                            <Form.Label sm="3" column="sm">Max Reps:</Form.Label>
                            <Col sm="3">
                                <Form.Control
                                    type="text"
                                    name="maxReps"
                                    value={maxReps}
                                    onChange={(e) => setMaxReps(e.target.value)}
                                    required />
                            </Col>
                            <Form.Label sm="3" column="sm">Time Cap:</Form.Label>
                            <Col sm="3">
                                <Form.Control
                                    type="text"
                                    name="timeCap"
                                    value={timeCap}
                                    onChange={(e) => setTimeCap(e.target.value)}
                                    required />
                            </Col>

                        </Form.Group>
                        <Form.Group as={Row} controlId="scoringType" className="mb-3">
                            <Form.Label sm="3" column="sm">Scoring Type:</Form.Label>
                            <Col sm="9">
                                <Form.Check
                                    inline
                                    type="radio"
                                    label="Reps"
                                    name="scoringType"
                                    value="reps"
                                    checked={scoringType === "reps"}
                                    onChange={(e) => setScoringType(e.target.value)}
                                />
                                <Form.Check
                                    inline
                                    type="radio"
                                    label="Time"
                                    name="scoringType"
                                    value="time"
                                    checked={scoringType === "time"}
                                    onChange={(e) => setScoringType(e.target.value)}
                                />
                            </Col>
                        </Form.Group>
                        <Form.Group as={Row} controlId="tieBreaker" className="mb-3">
                            <Form.Label sm="3" column="sm">Tiebreaker Type:</Form.Label>
                            <Col sm="9">
                                <Form.Check
                                    inline
                                    type="radio"
                                    label="Reps"
                                    name="tieBreakerType"
                                    value="reps"
                                    checked={tieBreakerType === "reps"}
                                    onChange={(e) => setTieBreakerType(e.target.value)}
                                />
                                <Form.Check
                                    inline
                                    type="radio"
                                    label="Time"
                                    name="tieBreakerType"
                                    value="time"
                                    checked={tieBreakerType === "time"}
                                    onChange={(e) => setTieBreakerType(e.target.value)}
                                />
                                <Form.Check
                                    inline
                                    type="radio"
                                    label="None"
                                    name="tieBreakerType"
                                    value="none"
                                    checked={tieBreakerType === "none"}
                                    onChange={(e) => {
                                        setTieBreakerType(e.target.value)
                                    }}
                                />
                            </Col>
                        </Form.Group>
                        <Button type="submit" variant="outline-primary" className="mx-auto d-block">Create Workout</Button>
                    </Form>
                </Card.Body>
            </Card>
        </Container>
    );
}
